import { createTheme } from '@one-thd/sui-atomic-components';

const LaborDaySecondaryTwo = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

LaborDaySecondaryTwo.palette['--sui-palette-background-primary'] = '105 102 68';
LaborDaySecondaryTwo.palette['--sui-palette-button-background-primary'] = '255 255 255';
LaborDaySecondaryTwo.palette['--sui-palette-text-primary'] = '255 255 255';
LaborDaySecondaryTwo.palette['--sui-palette-text-subtle'] = '255 255 255';

export { LaborDaySecondaryTwo };
